import classNames from 'classnames';
import React, { ElementType, forwardRef, HTMLAttributes } from 'react';
import { Shape } from './shapes';
import * as css from './Silhouette.css';

export { Shape } from './shapes';

export type SilhouetteProps = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  shape: Shape;
  size?: '200' | '300' | '400' | '500';
};

export const Silhouette = forwardRef<HTMLElement, SilhouetteProps>(function Silhouette(
  { as: As = 'div', shape, size, className, children, ...props },
  ref
) {
  return (
    <As
      className={classNames(css.silhouette({ shape, size }), className)}
      ref={ref}
      {...props}
    >
      {children}
    </As>
  );
});
